<template>
  <v-container>
    <v-card class="mx-auto" max-width="800" color="grey darken-2">
      <v-container>
        <v-row align-content-center>
          <v-col
            v-for="card in cards"
            :key="card.title"
            class="mx-auto"
            sm="6"
            md="6"
            xs="12"
            lg="6"
            xl="6"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card :disabled="card.disabled" color="grey darken-3" router :to="card.route">
                <v-row>
                  <v-col align="center" justify="center" pa-5>
                    <v-avatar size="150" tile centered>
                      <v-img :src="card.src"></v-img>
                    </v-avatar>
                    <v-expand-transition>
                      <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out green v-card--reveal display-3 white--text"
                        style="height: 100%;"
                      ></div>
                    </v-expand-transition>
                  </v-col>
                </v-row>
                <v-card-title primary-title>
                  <span class="headline white--text" v-text="card.title"></span>
                </v-card-title>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >

      <v-card>
        <v-card-title
          class="headline grey"
          primary-title
        >
        Wartungsarbeiten
        </v-card-title>

        <v-card-text>
        Aufgrung von Wartungsarbeiten an unserem Onlineshop ist ein Gutscheinkauf über diesen momentan nicht möglich. <br>
        Gerne können Sie telefonisch oder per Email einen Gutschein kaufen. <br>
        Vielen Dank für Ihr Verständnis.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      </div>

      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({

    dialog: true,

    cards: [
      {
        title: "Gutschein kaufen",
        src: "/img/gift-card.svg",
        disabled: true,
        route: "/select"
      },
      {
        title: "Termin buchen",
        src: "/img/calendar.svg",
        disabled: true,
        route: "/date/select"
      },
      {
        title: "Fahrt starten",
        src: "/img/start-line.svg",
        disabled: true
      },
      {
        title: "Fahrt stornieren",
        src: "/img/cancel.svg",
        disabled: true
      }
    ]
  })
};
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>
